import { DataGridPro } from "@mui/x-data-grid-pro";
import { useMemo } from "react";
import { useTranslation } from "react-i18next";
import { Toolbar } from "./Toolbar";
import { TimeCell } from "./TimeCell";
import { SelectCell } from "./SelectCell";
import { ActionCell } from "./ActionCell";

const Table = ({ rows, setRows, selectedDay, loadingGettingShift }) => {
	const { t } = useTranslation();

	const columns = useMemo(
		() => [
			{
				field: "start_ts",
				headerName: t(
					"timekeeper.schedule.table.modals.add.table.columns.start"
				),
				flex: 2,
				renderCell: (params) => (
					<TimeCell
						params={params}
						rows={rows}
						setRows={setRows}
						selectedDay={selectedDay}
					/>
				),
			},
			{
				field: "end_ts",
				headerName: t(
					"timekeeper.schedule.table.modals.add.table.columns.end"
				),
				flex: 2,
				renderCell: (params) => (
					<TimeCell
						params={params}
						rows={rows}
						setRows={setRows}
						selectedDay={selectedDay}
					/>
				),
			},
			{
				field: "type",
				headerName: t(
					"timekeeper.schedule.table.modals.add.table.columns.type.title"
				),
				flex: 2,
				renderCell: (params) => (
					<SelectCell params={params} rows={rows} setRows={setRows} />
				),
			},
			{
				field: "actions",
				headerName: t(
					"timekeeper.schedule.table.modals.add.table.columns.actions"
				),
				flex: 1,
				sortable: false,
				renderCell: (params) => (
					<ActionCell params={params} rows={rows} setRows={setRows} />
				),
			},
		],
		[t, rows, setRows, selectedDay]
	);

	return (
		<>
			<DataGridPro
				rows={rows}
				columns={columns}
				loading={loadingGettingShift}
				slots={{
					toolbar: Toolbar,
				}}
				slotProps={{
					toolbar: { rows, setRows, selectedDay },
				}}
				hideFooter
				sx={{
					minHeight: 145,
				}}
				getRowHeight={() => "auto"}
			/>
		</>
	);
};

export { Table };
